<template>
  <div class="page-wrapper pb-24 lg:pb-32">
    <MarkupSectionHeaderH1
      :config-data="{
        TitleFirstRow: modifiedConfigData.HeaderFirstRow.Title,
        TitleStyle: modifiedConfigData.HeaderFirstRow.TitleStyle,
      }"
    >
    </MarkupSectionHeaderH1>

    <MarkupSectionText
      v-if="modifiedConfigData.Ingress.Text"
      class="mt-16 md:mt-24"
      :config-data="modifiedConfigData.Ingress"
    ></MarkupSectionText>
    <MarkupUspWrapper
      class="mt-16 lg:mt-24"
      :config-data="modifiedConfigData.Usp"
    ></MarkupUspWrapper>
  </div>

  <div class="page-wrapper pt-24 pb-8 lg:pb-16">
    <MarkupFilterSection :config-data="modifiedConfigData.Filter" />
  </div>
</template>

<script lang="ts" setup>
interface Props {
  configData: {
    Header: {
      Text?: string;
    };
    Ingress: {
      Text?: string;
    };
    BulletList: {
      Bullet: {
        Row1: string;
        Row2: string;
      }[];
    };
    FilterSettings: {
      DefaultDownpaymentTime?: number;
      DefaultPlanId?: number;
    };
  };
}

const props = defineProps<Props>();

const modifiedConfigData = {
  HeaderFirstRow: {
    Title: props.configData.Header.Text ?? 'Begagnat',
    TitleStyle: 'boxed',
  },
  Ingress: {
    Text: props.configData.Ingress?.Text ?? '',
  },
  Usp: {
    Items: props.configData.BulletList.Bullet.map((item: any) => ({
      Icon: 'check-circle-white',
      Label: item.Row1,
      SubLabel: item.Row2,
    })),
  },
  Filter: {
    Placeholder: 'Sök mobiltelefoner...',
    DrawerDescription:
      'Här kan du välja vilka mobiler du vill se och vad priset skall baseras på för abonnemang och delbetalning.',
    DefaultPlanId: props.configData.FilterSettings.DefaultPlanId,
    DefaultDownPayment: props.configData.FilterSettings.DefaultDownpaymentTime,
  },
};
</script>

<style></style>
